"use client"
import React from 'react'

async function clickHandler(){
    
}

const NFButtons = () => {
  return (
    <div className='md:grid md:grid-cols-2 '>
                  <input type='button' value={"Go Home"} className='btn bg-primary mt-10 mb-5 flex md:flex-none md:m-10 md:text-xl'></input>
                  <input type='button' value={"Support"} className='btn bg-primary flex md:m-10 md:flex-none md:text-xl'></input>
    </div>
  )
}

export default NFButtons